import { useState, useEffect } from 'react';
import { LabelInput, MoneyInput } from '../../../components/Input/Input';
import { FaPercentage } from 'react-icons/fa';
import { BsTrashFill } from 'react-icons/bs';
import { inputMoneyChange } from '../../../core/utils/string';
import { useHasEditedStatus } from './HasEditedContext';
import { normalizeDecimalSeparator } from '../utils/functions';

export const ColumnsPieceServiceRenderer = ({ data, changePartsValue }) => {
  const [displayUnitaryValue, setDisplayUnitaryValue] = useState('');
  const { hasEdited, setHasEdited } = useHasEditedStatus();

  useEffect(() => {
    setHasEdited(false);
  }, []);

  useEffect(() => {
    if (!hasEdited) {
      const unitaryValueParsed = parseFloat(normalizeDecimalSeparator(data.unitaryValue));
      const profitParsed = parseFloat(normalizeDecimalSeparator(data.profit)) || 0;
      const profitMargin = parseFloat(normalizeDecimalSeparator(data.profit_margin));
      const discountParsed = parseFloat(normalizeDecimalSeparator(data.discount)) || 0;
      const discountPercentage = parseFloat(normalizeDecimalSeparator(data.discount_percentage));

      let finalUnitaryValue = unitaryValueParsed;

      if (!isNaN(unitaryValueParsed) && unitaryValueParsed > 0) {
        // Aplica o lucro
        if (!isNaN(profitMargin)) {
          finalUnitaryValue += unitaryValueParsed * (profitMargin / 100);
        } else {
          finalUnitaryValue += profitParsed;
        }

        // Aplica o desconto
        if (!isNaN(discountPercentage)) {
          finalUnitaryValue = finalUnitaryValue * (1 - discountPercentage / 100);
        } else if (discountParsed > 0) {
          finalUnitaryValue -= discountParsed;
        }

        setDisplayUnitaryValue(finalUnitaryValue);
      } else {
        setDisplayUnitaryValue('');
      }
    }
  }, [data.unitaryValue, data.profit, data.profit_margin, data.discount, data.discount_percentage, hasEdited]);

  const handleQuantityValueChange = (newQuantity) => {
    if (data.quantity === newQuantity) return;

    const quantityNum = parseFloat(newQuantity) || 0;
    const unitaryValueNum = parseFloat(data.unitaryValue) || 0;
    const newTotalValue = quantityNum * unitaryValueNum;

    changePartsValue('quantity', data, newQuantity);
    changePartsValue('value', data, newTotalValue);
  };

  const handlePartsUnitaryValueChange = (eventOrValue) => {
    setHasEdited(true);

    if (eventOrValue === '' || eventOrValue == null) {
      changePartsValue('unitaryValue', data, '');
      changePartsValue('value', data, '');
      setDisplayUnitaryValue('');
      return;
    }

    let newBaseValue = inputMoneyChange(eventOrValue);
    newBaseValue = String(newBaseValue).replace(/[,]/g, '.');

    const quantityNum = parseFloat(data.quantity) || 0;
    const newTotalValue = quantityNum * newBaseValue;

    changePartsValue('unitaryValue', data, newBaseValue);
    changePartsValue('value', data, newTotalValue);
    setDisplayUnitaryValue(newBaseValue);
  };

  return (
    <div
      className="column-service"
      style={{ maxHeight: '100%', height: '100%', padding: '8px 0' }}
    >
      <div style={{ paddingLeft: '10px' }}>{data.name}</div>
      <div
        style={{
          gap: '5px',
          display: 'flex',
          alignItems: 'center',
          paddingLeft: '5px',
        }}
      >
        <div className="field-actions-budget budget-piece-quantity">
          <LabelInput
            type="text"
            className="budget-service-input"
            onChange={handleQuantityValueChange}
            placeholder={'QUANTIDADE'}
            value={data.quantity}
          />
        </div>
        <div className="field-actions-budget budget-piece-unit">
          <MoneyInput
            type="number"
            className="budget-service-input"
            onChange={handlePartsUnitaryValueChange}
            placeholder={'Valor unit'}
            value={displayUnitaryValue}
          />
        </div>
        <div className="field-actions-budget budget-piece-total">
          <MoneyInput
            type="number"
            disabled={true}
            className="budget-service-input"
            value={
              data.value == null || isNaN(parseFloat(data.value))
                ? 'R$0'
                : parseFloat(displayUnitaryValue * data?.quantity)
            }
          />
        </div>
      </div>
    </div>
  );
};

export const PieceActionCell = ({ data, onRemove, openEditModal }) => {
  return (
    <div className="field-actions">
      <FaPercentage
        className="icon-action edit"
        onClick={() => openEditModal(data)}
      />
      <BsTrashFill
        className="icon-action trash"
        onClick={() => onRemove(data)}
      />
    </div>
  );
};
